export const palette = {
  KB_Primary: '#FFD300',
  KB_Primary_dark: '#b29300',
  White: '#FFFFFF',
  COVER_DESCRIPTION: 'rgba(255, 255, 255, 0.7)',
  Black: '#000000',
};
